export const slugify = (str) => {
    // Remove accents
    str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    // Replace spaces with -
    str = str.replace(/\s+/g, "-");

    // Remove all characters that are not letters, numbers, - or _
    str = str.replace(/[^a-zA-Z0-9-_]/g, "");

    // Replace multiple - with single -
    str = str.replace(/-{2,}/g, "-");

    // Remove - from start and end of string
    str = str.replace(/^-+|-+$/g, "");

    // Return lowercase string
    return str.toLowerCase();
};
